module.exports = __webpack_public_path__ + "a00d0be64229e84ace4f4e7e3145a646.fbx";